import React from 'react';
import './WhyChooseUs.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const WhyChooseUs = () => {
  const sectionRef = useScrollAnimation();
  const features = [
    {
      icon: '⭐',
      title: 'Expert Canadian Tax Knowledge',
      description: 'Specialized expertise in Canadian tax regulations, Ontario tax credits, and GST/HST housing rebates.'
    },
    {
      icon: '📋',
      title: 'Comprehensive Tax Preparation',
      description: 'Complete personal and corporate tax filing with maximum deductions and credits optimization.'
    },
    {
      icon: '🏢',
      title: 'Business Incorporation Specialists',
      description: 'Full incorporation services with corporate management, registration, and ongoing compliance support.'
    },
    {
      icon: '📊',
      title: 'Professional Bookkeeping Services',
      description: 'Accurate financial record management with chart of accounts, reconciliation, and financial statements.'
    },
    {
      icon: '🎯',
      title: 'Canada-Wide Expertise',
      description: 'Deep knowledge of Canadian tax credits, federal and provincial regulations, and business needs across the country.'
    },
    {
      icon: '🤝',
      title: 'Trusted Client Relationships',
      description: '500+ satisfied clients with 7+ years of experience and 100% compliance rate.'
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="why-choose-us section fade-in-left" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why Choose Us</h2>
          <p className="section-subtitle">Why Clients Trust Us with Their Accounting Needs</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="trust-section">
          <h3>Trust Profit Pioneers Accounting & Bookkeeping Inc.</h3>
          <div className="trust-stats">
            <div className="trust-stat">
              <div className="stat-number">500+</div>
              <div className="stat-label">Satisfied Clients</div>
            </div>
            <div className="trust-stat">
              <div className="stat-number">7+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="trust-stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Compliance Rate</div>
            </div>
            <div className="trust-stat">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <h3>Ready to Experience the Difference?</h3>
          <p>Join hundreds of satisfied clients who trust us with their accounting needs</p>
          <button 
            onClick={() => scrollToSection('contact')} 
            className="btn btn-primary"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
